import React from 'react';
import { Typography } from '@wds/typography';
import { BylineProps } from './types';

export default function PackageByline({ byline }: BylineProps): JSX.Element {
  if (!byline) {
    return <></>;
  }
  return (
    <Typography component="p" variant="bodySm" data-testid="PackageByline" align="center" color="secondary">
      {byline}
    </Typography>
  );
}
